@import "../../scss";

.root {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: var(--color-swamp-green);
  color: var(--color-cream);
}

.root:global(.enter) {
  opacity: 0;
}

.root:global(.enter-active) {
  transition: opacity 0.3s ease;
  opacity: 1;
}

.root:global(.exit) {
  opacity: 1;
}

.root:global(.exit-active) {
  transition: opacity 0.3s ease;
  opacity: 0;
}

:global {
  @keyframes grow {
    0% {
      transform: scale(1) rotate(0);
    }

    100% {
      transform: scale(1.2) rotate(-3deg);
    }
  }
}

.image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  animation: grow 15s ease-out forwards;
}

.video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.shim {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2));
}

.inner {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.options {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;

  @media (orientation: portrait) {
    flex-direction: column;
    width: 66%;
  }
}

.options button:first-child {
  @media (orientation: landscape) {
    margin-right: 1.3rem;
  }

  @media (orientation: portrait) {
    margin-bottom: 1.75rem;
  }

  @media (max-height: 600px) {
    margin-bottom: 0.75rem;
  }
}

.options button {
  align-self: stretch;
}

.intro {
  @include typo--intro;
  width: 85%;
  max-width: 55rem;
  text-align: center;
  margin-bottom: var(--spacer-6);

  @include media-breakpoint-down("md") {
    margin-bottom: var(--spacer-4);
    max-width: 27rem;
  }

  @include media-breakpoint-down("sm") {
    width: 70%;
  }
}

.intro span {
  display: inline-block;
}

.future-nature {
  height: auto;
  flex-shrink: 0;
  margin-bottom: 2rem;
  max-width: 17rem;
  width: 55%;
}
